export { getLessonApi, completeLessonApi, completeSubscriptionLessonApi } from './api/lesson.api';
export { getNotesByLessonApi, removeNoteApi } from './api/note.api';

export { useActiveLesson } from './hooks/useActiveLesson';

export { parseNoteDTO, getLessonContentById } from './lib/parsers';
export { generateModuleWithLessonTOC } from './lib/toc';

export { useLessonStore } from './model/store';
export type {
  Lesson,
  LessonStats,
  LessonContent,
  Note,
  NoteAnchor,
  NoteDTO,
  NoteAnchorDTO,
  NewNoteDTO,
} from './model/types';

export { default as NoteComponent } from './ui/Note/Note';
